import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { useForm, useFormValidation } from '../../../hooks';
import { useLaboratorio } from '../hooks/useLaboratorio';
import { usePacienteLaboratorioEditar } from '../hooks/usePacienteLaboratorioEditar';

import { DateInput, Error, Forbidden, LightButton, Loader, MultiFileUpdate, MultiFormArchivos, MultiFormEstudios, PrimaryButton, TextAreaInput } from '../../../components';

import styles from '../PacienteConsulta.module.css';

export const LaboratorioEditar = ({ id, laboratorioData, cancelar }) => {

    const { permisos } = useSelector(state => state.auth);

    const { laboratorioQuery: { isLoading, isError, data: laboratorio } } = useLaboratorio();

    const { updateLaboratorioMutation: { mutate: updateLaboratorio, isPending } } = usePacienteLaboratorioEditar(id);

    const [resetFields, setResetFields] = useState(moment().unix());

    let estudiosAux = (typeof laboratorioData.estudios !== 'undefined' && laboratorioData.estudios.length > 0) ? laboratorioData.estudios.map(estudio => ({id: estudio._id, estudio: estudio._id})) : [{id: moment().unix(), estudio: ''}];

    const { estudios, fecha, comentarios, archivos, archivosPrevios, onInputChange, onResetForm } = useForm({ estudios: estudiosAux, fecha: laboratorioData.fecha, comentarios: laboratorioData.comentarios, archivos: [{id: moment().unix(), archivo: null}], archivosPrevios: laboratorioData.archivos });

    const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation, onResetValidation } = useFormValidation([{field: 'estudios', default: false}, {field: 'fecha', default: true}, {field: 'comentarios', default: true}]);

    const handleOnFieldChange = (e) => {
        onInputChange(e);
    }

    const handleClearForm = () => {
        onResetForm();
        onResetValidation();
        cancelar();
        setResetFields(moment().unix());
    }

    const onSubmit = (e) => {
        e.preventDefault();

        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid){
            updateLaboratorio({ data: { estudios: JSON.stringify(estudios.filter(estudio => estudio.estudio !== "").map(estudio => estudio.estudio)), fecha, comentarios, archivos: archivos.filter(archivo => archivo.archivo !== null).map(archivo => archivo.archivo), archivosPrevios: JSON.stringify(archivosPrevios.map(archivo => archivo.id)) }, id: laboratorioData._id, success:  handleClearForm});
        }else{
            startFormValidation();
        }
    }

    return (permisos.laboratorioUpdate) ? (
        <>
            {(isLoading)
                ? <Loader />
                : <>
                    {(isError)
                        ? <Error />
                        : <>
                            <div>Editar</div>
                            <div className="row">
                                <div className="col">
                                    <div className={styles.estudioContainer}>
                                        <form onSubmit={onSubmit}>
                                            <div className="row">
                                                <div className="col">
                                                    <DateInput
                                                        formFieldStatus={ formFields['fecha'].status }
                                                        label="Fecha"
                                                        name="fecha"
                                                        onChange={ handleOnFieldChange }
                                                        required={ true }
                                                        requiredIndicator={ true }
                                                        reset={resetFields}
                                                        setFormFieldValidation={ setFormFieldValidation }
                                                        value={ fecha }
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <MultiFormEstudios
                                                        formsStatus={ formFields['estudios'].status }
                                                        laboratorio={laboratorio}
                                                        name="estudios"
                                                        onFormsChange={ handleOnFieldChange }
                                                        reset={resetFields}
                                                        setFormValidation={ setFormFieldValidation }
                                                        value={estudios}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <MultiFormArchivos
                                                        formsStatus="checked"
                                                        name="archivos"
                                                        onFormsChange={ handleOnFieldChange }
                                                        reset={resetFields}
                                                        value={archivos}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <MultiFileUpdate
                                                        name="archivosPrevios"
                                                        onFormsChange={ handleOnFieldChange }
                                                        reset={resetFields}
                                                        value={archivosPrevios}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <TextAreaInput
                                                        formFieldStatus={ formFields['comentarios'].status }
                                                        label="Comentarios"
                                                        name="comentarios"
                                                        onChange={ handleOnFieldChange }
                                                        required={ false }
                                                        requiredIndicator={ false }
                                                        setFormFieldValidation={ setFormFieldValidation }
                                                        value={ comentarios }
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 col-lg-6">
                                                    <LightButton
                                                        block={true}
                                                        icon="X"
                                                        marginRight={true}
                                                        marginTop={false}
                                                        onClick={handleClearForm}
                                                        text="Cancelar"
                                                        type="button"
                                                    />
                                                </div>
                                                <div className="col-md-12 col-lg-6 mt-md-3 mt-lg-0">
                                                    <PrimaryButton
                                                        block={true}
                                                        disabled={isPending || formValidationStatus === 'checking'}
                                                        icon="Check"
                                                        marginTop={false}
                                                        text="Guardar"
                                                        type="submit"
                                                    />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </>
            }
        </>
    ) : <div><Forbidden /></div>
}

LaboratorioEditar.propTypes = {
    id: PropTypes.string.isRequired,
    laboratorioData: PropTypes.object.isRequired,
    cancelar: PropTypes.func.isRequired,
}